import { CmsCancelEligibilityApi, CmsCreateCancelApi, } from '../api/cms/cancel-items';
import { getFulfillmentStatus } from '../components/order-details/util/FulfillmentStatus';
import { CANCEL_ALERT_MESSAGE } from '../constants/cancels';
import { FeatureSwitches } from '../constants/feature-switches';
import { FULFILLMENT_TYPE } from '../constants/status';
import { pushErrorEvent, setPageInfo } from '../utils/analytics';
import { getWindow } from '../utils/general';
export var CmsCreateCancel = function (request, isAuthTHDUser, xAuthGuestToken, traceId) {
    return CmsCreateCancelApi(request, isAuthTHDUser, xAuthGuestToken, traceId);
};
export var CmsCancelElibility = function (fulfillmentGroup, orderDetailsData, isSTHorBOSSQtyCancel, isSTHorBOSSRemorseCancel, isPostRemorseCancel, handleCancelEligibilityResult, customerType, isAuthTHDUser, isLineItemCancelEnabled) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;
    var orderNumber = orderDetailsData.orderNumber;
    var xAuthGuestToken = orderDetailsData.xAuthGuestToken;
    var fulfillmentType = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentType;
    var lineCancelIdsAndQtys;
    var lineItems = [];
    var workOrderNumber;
    var fulfillmentTypeForCMS = '';
    var bodfsStoreNumber = '';
    var bossStoreNumber = '';
    // ZipCode for analytics reporting for BODFS and MA items
    var zipCode;
    // Currently only used to skip Eligibility call if BOSS PRCR and isBossPostShipped is true
    var skipEligibilityCall = false;
    var BOSS_POST_SHIPPED_ELIGIBILITY_SWITCH = (_e = (_d = (_c = (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.__EXPERIENCE_PROPS__) === null || _b === void 0 ? void 0 : _b.expConfiguration) === null || _c === void 0 ? void 0 : _c.disableBossPostShippedEligibility) === null || _d === void 0 ? void 0 : _d.toLowerCase()) !== null && _e !== void 0 ? _e : 'true';
    if (isPostRemorseCancel && orderDetailsData) {
        var postRemorseFulfillmentGroups = orderDetailsData.fulfillmentGroups;
        postRemorseFulfillmentGroups.forEach(function (postRemorseFulfillmentGroup) {
            var _a;
            var postRemorseFulfillmentType = postRemorseFulfillmentGroup.fulfillmentType === FULFILLMENT_TYPE.STH
                ? 'STH'
                : 'BOSS';
            skipEligibilityCall =
                postRemorseFulfillmentGroup.isBossPostShipped &&
                    BOSS_POST_SHIPPED_ELIGIBILITY_SWITCH === 'true'
                    ? postRemorseFulfillmentType === 'BOSS'
                    : false;
            (_a = postRemorseFulfillmentGroup.lineItems) === null || _a === void 0 ? void 0 : _a.forEach(function (lineItem) {
                var _a, _b, _c;
                var currentQuantity = lineItem.currentQuantity
                    ? lineItem.currentQuantity
                    : lineItem.quantity;
                if (postRemorseFulfillmentType === 'BOSS') {
                    var storeNumber = void 0;
                    if ((_b = (_a = postRemorseFulfillmentGroup === null || postRemorseFulfillmentGroup === void 0 ? void 0 : postRemorseFulfillmentGroup.storePickup) === null || _a === void 0 ? void 0 : _a.store) === null || _b === void 0 ? void 0 : _b.number) {
                        storeNumber = (_c = postRemorseFulfillmentGroup.storePickup) === null || _c === void 0 ? void 0 : _c.store.number;
                    }
                    else if (lineItem.storeNumber === undefined) {
                        storeNumber = '8119';
                    }
                    else {
                        storeNumber = lineItem.storeNumber;
                    }
                    lineItems.push({
                        id: lineItem.lineId,
                        fulfillmentType: postRemorseFulfillmentType,
                        qtyToCancel: currentQuantity,
                        storeNumber: storeNumber,
                    });
                }
                else {
                    lineItems.push({
                        id: lineItem.lineId,
                        fulfillmentType: postRemorseFulfillmentType,
                        qtyToCancel: currentQuantity,
                    });
                }
            });
        });
    }
    else if (fulfillmentGroup && fulfillmentType) {
        var orderFulfillment = getFulfillmentStatus(fulfillmentType);
        var isFulfillmentMAorBODFSorDFS = orderFulfillment.isFulfillmentMAorBODFSorDFS, isBODFS_1 = orderFulfillment.isBODFS, isBOPIS = orderFulfillment.isBOPIS, isBOSS_1 = orderFulfillment.isBOSS;
        switch (fulfillmentType) {
            case FULFILLMENT_TYPE.STH:
                fulfillmentTypeForCMS = 'STH';
                break;
            case FULFILLMENT_TYPE.BOSS:
                fulfillmentTypeForCMS = 'BOSS';
                break;
            case FULFILLMENT_TYPE.DFS:
                fulfillmentTypeForCMS = FULFILLMENT_TYPE.DFS;
                break;
            case FULFILLMENT_TYPE.BODFS:
                fulfillmentTypeForCMS = 'BODFS';
                break;
            case FULFILLMENT_TYPE.BOPIS:
                fulfillmentTypeForCMS = 'BOPIS';
                break;
            case FULFILLMENT_TYPE.MA:
                fulfillmentTypeForCMS = 'MA';
                break;
            case FULFILLMENT_TYPE.MISC:
                fulfillmentTypeForCMS = FULFILLMENT_TYPE.MISC;
                break;
            default:
                break;
        }
        if (fulfillmentType === FULFILLMENT_TYPE.BODFS) {
            bodfsStoreNumber =
                (_j = (_h = (_g = (_f = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.bodfsDeliveryAndHandling) === null || _f === void 0 ? void 0 : _f.bodfsDeliveries) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.storeId) !== null && _j !== void 0 ? _j : '';
            zipCode =
                (_o = (_m = (_l = (_k = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.bodfsDeliveryAndHandling) === null || _k === void 0 ? void 0 : _k.bodfsDeliveries) === null || _l === void 0 ? void 0 : _l[0].deliveryAddress) === null || _m === void 0 ? void 0 : _m.postalDetails) === null || _o === void 0 ? void 0 : _o.zipCode;
        }
        if (fulfillmentType === FULFILLMENT_TYPE.BODFS ||
            fulfillmentType === FULFILLMENT_TYPE.DFS) {
            workOrderNumber =
                (_s = (_r = (_q = (_p = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.bodfsDeliveryAndHandling) === null || _p === void 0 ? void 0 : _p.bodfsDeliveries) === null || _q === void 0 ? void 0 : _q[0]) === null || _r === void 0 ? void 0 : _r.workOrderNo) !== null && _s !== void 0 ? _s : '';
        }
        if (fulfillmentType === FULFILLMENT_TYPE.BOSS) {
            bossStoreNumber = (_v = (_u = (_t = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.storePickup) === null || _t === void 0 ? void 0 : _t.store) === null || _u === void 0 ? void 0 : _u.number) !== null && _v !== void 0 ? _v : '';
        }
        if (fulfillmentType === FULFILLMENT_TYPE.MA) {
            workOrderNumber =
                (_z = (_y = (_x = (_w = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.shippingAndHandling) === null || _w === void 0 ? void 0 : _w.applianceDeliveries) === null || _x === void 0 ? void 0 : _x[0]) === null || _y === void 0 ? void 0 : _y.workOrderNo) !== null && _z !== void 0 ? _z : '';
            zipCode =
                (_2 = (_1 = (_0 = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.shippingAndHandling) === null || _0 === void 0 ? void 0 : _0.deliveryAddress) === null || _1 === void 0 ? void 0 : _1.postalDetails) === null || _2 === void 0 ? void 0 : _2.zipCode;
        }
        var parsedLineItems = void 0;
        if (isSTHorBOSSRemorseCancel &&
            !isLineItemCancelEnabled &&
            FeatureSwitches.enableDiscountCancelRestriction) {
            parsedLineItems = orderDetailsData.fulfillmentGroups
                .filter(function (groups) { return groups.lineItems !== undefined; })
                .map(function (group) { var _a; return (_a = group.lineItems) === null || _a === void 0 ? void 0 : _a.map(function (lineItem) { return lineItem; }); })
                .flat();
        }
        else {
            parsedLineItems = fulfillmentGroup.lineItems;
        }
        lineCancelIdsAndQtys = parsedLineItems === null || parsedLineItems === void 0 ? void 0 : parsedLineItems.map(function (lineItem) {
            var _a, _b;
            var currentQuantity = (_b = (_a = lineItem.workOrderFulfilledQty) !== null && _a !== void 0 ? _a : lineItem.currentQuantity) !== null && _b !== void 0 ? _b : lineItem.quantity;
            return {
                lineId: lineItem.lineId,
                canceledQuantity: isSTHorBOSSQtyCancel ? 0 : currentQuantity,
                workOrderNumber: workOrderNumber,
            };
        });
        if (parsedLineItems) {
            if (isFulfillmentMAorBODFSorDFS || isBOPIS || isBOSS_1) {
                lineItems = parsedLineItems.map(function (lineItem) {
                    var _a, _b;
                    var storeNumber;
                    if (isBODFS_1 && bodfsStoreNumber !== '') {
                        storeNumber = bodfsStoreNumber;
                    }
                    else if (isBOSS_1 && bossStoreNumber !== '') {
                        storeNumber = bossStoreNumber;
                    }
                    else if (lineItem.storeNumber === undefined) {
                        storeNumber = '8119';
                    }
                    else {
                        storeNumber = lineItem.storeNumber;
                    }
                    return {
                        id: lineItem.lineId,
                        fulfillmentType: fulfillmentTypeForCMS,
                        qtyToCancel: (_b = (_a = lineItem.workOrderFulfilledQty) !== null && _a !== void 0 ? _a : lineItem.currentQuantity) !== null && _b !== void 0 ? _b : lineItem.quantity,
                        storeNumber: storeNumber,
                    };
                });
            }
            else {
                lineItems = parsedLineItems.map(function (lineItem) {
                    var _a, _b;
                    return ({
                        id: lineItem.lineId,
                        fulfillmentType: fulfillmentTypeForCMS,
                        qtyToCancel: (_b = (_a = lineItem.workOrderFulfilledQty) !== null && _a !== void 0 ? _a : lineItem.currentQuantity) !== null && _b !== void 0 ? _b : lineItem.quantity,
                    });
                });
            }
        }
    }
    var request = {
        orderId: orderNumber,
        emailId: orderDetailsData.emailId,
        net: orderDetailsData.net,
        lineItems: lineItems,
    };
    CmsCancelEligibilityRequest(request, lineCancelIdsAndQtys, isSTHorBOSSQtyCancel, isSTHorBOSSRemorseCancel, isPostRemorseCancel, fulfillmentTypeForCMS, handleCancelEligibilityResult, skipEligibilityCall, customerType, isAuthTHDUser, fulfillmentType, bodfsStoreNumber, bossStoreNumber, workOrderNumber, zipCode, xAuthGuestToken, orderDetailsData.traceId);
};
var CmsCancelEligibilityRequest = function (request, lineCancelIdsAndQtys, isSTHorBOSSQtyCancel, isSTHorBOSSRemorseCancel, isPostRemorseCancel, fulfillmentTypeForCMS, handleCancelEligibilityResult, skipEligibilityCall, customerType, isAuthTHDUser, fulfillmentType, bodfsStoreNumber, bossStoreNumber, workOrderNumber, zipCode, xAuthGuestToken, traceId) {
    var cancelInfo = {
        lineCancelIdsAndQtys: lineCancelIdsAndQtys,
        isOrderCancelable: false,
        isError: false,
        isSTHorBOSSQtyCancel: isSTHorBOSSQtyCancel,
        isSTHorBOSSRemorseCancel: isSTHorBOSSRemorseCancel,
        isPostRemorseCancel: isPostRemorseCancel,
        fulfillmentTypeForCMS: fulfillmentTypeForCMS,
        customerType: customerType,
        fulfillmentType: fulfillmentType,
        bodfsStoreNumber: bodfsStoreNumber,
        bossStoreNumber: bossStoreNumber,
        workOrderNumber: workOrderNumber,
        zipCode: zipCode,
        xAuthGuestToken: xAuthGuestToken,
    };
    if (skipEligibilityCall) {
        cancelInfo.isOrderCancelable = true;
        handleCancelEligibilityResult(cancelInfo);
    }
    else {
        CmsCancelEligibilityApi(request, isAuthTHDUser, xAuthGuestToken, traceId)
            .then(function (response) {
            if (response.data.data.isOrderCancellable) {
                cancelInfo.isOrderCancelable = response.data.data.isOrderCancellable;
                handleCancelEligibilityResult(cancelInfo);
            }
            else {
                if (cancelInfo.isSTHorBOSSQtyCancel) {
                    setPageInfo('error', 'page', 'order details>cancel items', CANCEL_ALERT_MESSAGE.ERROR, 'n/a');
                }
                else if (cancelInfo.isPostRemorseCancel) {
                    pushErrorEvent('request cancellation drawer: post-remorse', 'n/a', "The item(s) scheduled for delivery can't be canceled. See our Returns Policy for more options.", 'inline');
                }
                else {
                    pushErrorEvent('confirm cancellation drawer: remorse', 'n/a', CANCEL_ALERT_MESSAGE.ERROR, 'inline');
                }
                handleCancelEligibilityResult(cancelInfo);
            }
        })
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            .catch(function (_error) {
            var _a, _b;
            cancelInfo.isError = true;
            var errorCode = ((_a = _error.response) === null || _a === void 0 ? void 0 : _a.data)
                ? ((_b = _error.response) === null || _b === void 0 ? void 0 : _b.data).errors[0].code.toString()
                : 'n/a';
            if (cancelInfo.isSTHorBOSSQtyCancel) {
                setPageInfo('error', 'page', 'order details>cancel items', CANCEL_ALERT_MESSAGE.ERROR, errorCode);
            }
            else if (cancelInfo.isPostRemorseCancel) {
                pushErrorEvent('request cancellation drawer: post-remorse', errorCode, "The item(s) scheduled for delivery can't be canceled. See our Returns Policy for more options.", 'inline');
            }
            else {
                pushErrorEvent('confirm cancellation drawer: remorse', errorCode, CANCEL_ALERT_MESSAGE.ERROR, 'inline');
            }
            handleCancelEligibilityResult(cancelInfo);
        });
    }
};
